import anime from 'animejs/lib/anime.es.js'; 
import tippy from 'tippy.js'; 

let dotstida = document.querySelectorAll(".animacion_tida .dot");
const main_image = document.querySelector(".animacion_tida");
const btn_close = document.querySelector(".animacion_tida__close"); 
const mainvideo = document.querySelector(".animacion_tida__mainvideo");
const transition_video = document.querySelector(".animacion_tida__transitionvideo");
const content_info = document.querySelector(".animacion_tida__information");
const container_producto = document.querySelector(".animacion_tida__product-container");
let current_animation = document.querySelector(".animacion_tida"); 

if(current_animation){
    let data_animation = JSON.parse(current_animation.dataset.info);

    initAnimation();
    transition_video.addEventListener('play', e => {
        let info = e.target.dataset;
        if(info.continue == "true"){
            //console.log("continua ", info);
            setTimeout(() => {
                transiciontomainvideo(info.next);
            }, 850); 
        }
        else{
            //console.log("no continua", info);
            setTimeout(() => {
                transiciontoimage();
            }, 900);
        }
    });

    btn_close.addEventListener("click", e=>{
         try {
             
            transition_video.setAttribute("data-continue","false");
            transicionclose(e.target.dataset.url);
         } catch (error) {
            console.log("err anime back",error)
         }
    })
    dotstida.forEach(step=>{
        let num = step.dataset.step;
        let info = data_animation[Number(num)-1];
        // set atributes to step
        step.setAttribute("data-index",info.index);
        step.setAttribute("data-url",info.url);
        step.setAttribute("data-urlfinal",info.urlfinal);
        step.setAttribute("data-titulo",info.titulo);
        step.setAttribute("data-contenido",info.contenido);
        step.setAttribute("data-urlinicio",info.urlinicio);
        step.setAttribute("data-tooltip",info.tooltip);
        // end
        set_tooltip(step,info.tooltip); 
        step.addEventListener("click", (e)=>{
            let information = e.target.dataset;
            //ocultar la imagen principal
            //Desktop
            document.querySelector(".animacion_tida__contenido .title").innerHTML=information.titulo;
            document.querySelector(".animacion_tida__contenido .content").innerHTML=information.contenido;
            //Mobile 
            document.querySelector(".animacion_tida__contenido-mobile .title").innerHTML=information.titulo;
            document.querySelector(".animacion_tida__contenido-mobile .content").innerHTML=information.contenido;
            //mostrar el video main y cambiar su url, pero considerar si hay video de inicio
            if(information.urlinicio === ''){
                //console.log("inicio sin transicion ")
               init_withouttransition(information.url, information.index);
            }else{
                //console.log("inicio con transicion");
                transition_video.setAttribute("data-next",information.url);
                transition_video.setAttribute("data-continue","true");
                init_withtransition(information.urlinicio, information.index);                
            }
            btn_close.setAttribute("data-url",information.urlfinal); 
           // btn_close.querySelector("svg").setAttribute("data-url",information.urlfinal); 
        });  
    });
}

function init_withouttransition(url, index) {
    //ocultar imagen
    //mostrar mainvideo
    content_info.setAttribute("data-current",index);
    let currentstep = document.querySelector(`.animacion_tida__producto[data-step="${index}"]`);
    document.querySelector(".animacion_tida__contenido-mobile").removeAttribute("style");
    mainvideo.src=url;
    anime.timeline({
        easing: 'easeOutExpo',
        duration: 1000,
    }).add({
        targets: main_image, 
        opacity: [1, 0], 
        zIndex:[3 ,-1],
        duration:300,
        easing: 'linear'
    }).add({
        targets:mainvideo,
        opacity: [0, 1], 
        zIndex:[-1,3],
        duration:300,
        easing: 'linear',
        complete: function(anim) {
            if(currentstep != null ){
                container_producto.style.display = 'block';
            }
        }
    }).add({
        targets:currentstep,
        opacity: [0, 1], 
        zIndex:[-1,3],
        duration:300,
    });
}

function set_tooltip(element,contenido) {
    
    tippy(element, {
        content: contenido,
        placement:"top",
        delay: 0,
        inlinePositioning: true, 
        theme: 'conty',
    });
}

function init_withtransition(url, index) {
    //ocultar imagen
    //mostrar transicion
    content_info.setAttribute("data-current",index);
    let currentstep = document.querySelector(`.animacion_tida__producto[data-step="${index}"]`);
    document.querySelector(".animacion_tida__contenido-mobile").removeAttribute("style");
    
   try {
    
    anime.timeline({
        easing: 'easeOutExpo',
         duration: 750,
       }).add({
        targets: main_image, 
        opacity: [1, 0], 
        zIndex:[3 ,-1],
        duration:300,
        easing: 'linear' 
    }).add({
        targets: transition_video,
        opacity: [0, 1], 
        zIndex:[-1,3],
        duration:300,
        easing: 'linear',
        complete: function(anim) {
            transition_video.src=url;
            if(currentstep != null ){
                container_producto.style.display = 'block';
            }
        }
    }).add({
        targets:currentstep,
        opacity: [0, 1], 
        zIndex:[-1,3],
        duration:300,
    }); 
   } catch (error) {
    console.error("err",error)
   }
}
function transiciontomainvideo(url) { 
    anime.timeline({
        easing: 'easeOutExpo',
         duration: 1100,
       }).add({
        targets: transition_video, 
        opacity: [1, 0], 
        zIndex:[3 ,-1],
        duration:900,
        //delay:900,
        easing: 'easeInOutBounce' 
    })
    .add({
        targets: mainvideo,
        opacity: [0, 1], 
        zIndex:[-1,3],
        duration:100,
        easing: 'linear',
        complete: function(anim) {
            mainvideo.src=url;
        }
    },'-=200')
    .add({
        targets: content_info,
        opacity: [0, 1], 
        zIndex:[-1,3],
        duration:100,
        easing: 'linear',
    },'-=400');  
}

function transiciontoimage() {
    container_producto.style.display = 'none';
    document.querySelector(".animacion_tida__contenido-mobile").style.display="none";
    anime.timeline({
        easing: 'easeInOutBounce',
        duration: 800,
        delqy:900,
    }).add({
        targets: content_info,
        opacity: [1, 0], 
        zIndex:[3,-1],
        duration:100,
        easing: 'easeInOutBounce', 
        complete: function (anim) {
            //container_producto.style.display = 'none';
        }
    })
    .add({
        targets: transition_video, 
        opacity: [1, 0], 
        zIndex:[3 ,-1],
        duration:200,
        easing: 'easeInOutBounce' 
    })
    .add({
        targets: main_image,
        opacity: [0, 1], 
        zIndex:[-1,3], 
        duration:400,
        easing: 'easeInOutBounce',
    });
}

function transicionclose(url) {
    document.querySelectorAll(".animacion_tida__producto").forEach(el=> el.removeAttribute("style"));
    transition_video.setAttribute("data-continue","false");
    transition_video.src=url; 
    let tl = anime.timeline({
        easing: 'easeOutExpo',
         duration: 800, 
    });
    tl.add({
        targets:mainvideo, 
        opacity: [1, 0], 
        zIndex:[3 ,-1],
        duration:500,
        easing: 'linear',
    },'-=100')
    .add({
        targets:transition_video,
        opacity: [0, 1], 
        zIndex:[-1,3],
        duration:300,
        easing: 'linear',
    },'-=100');
}





function initAnimation() {
    anime({
        targets: main_image,
        opacity:1,
        visibility:'visible',
        duration: 100,
        easing: 'easeInOutQuad',
        loop:1,
    });
    anime({
        targets: content_info,
        opacity:0,
        visibility:'collapse',
        zIndex:-1,
        duration: 100,
        easing: 'easeInOutQuad',
        loop:1,
    });
    anime({
        targets: mainvideo,
        opacity:0,
        visibility:'collapse',
        zIndex:-1,
        duration: 100,
        easing: 'easeInOutQuad',
        loop:1,
    });
    anime({
        targets:transition_video,
        opacity:0,
        visibility:'collapse',
        zIndex:-1,
        duration: 100,
        easing: 'easeInOutQuad',
        loop:1,
    });
}





